import { render, staticRenderFns } from "./NamePhotoEmail.vue?vue&type=template&id=1471ef47&scoped=true"
import script from "./NamePhotoEmail.vue?vue&type=script&lang=js"
export * from "./NamePhotoEmail.vue?vue&type=script&lang=js"
import style0 from "./NamePhotoEmail.vue?vue&type=style&index=0&id=1471ef47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1471ef47",
  null
  
)

export default component.exports